import React from 'react';
import '../assets/css/contact.css';
import '../assets/css/custom.css';
import '../assets/js/contact.js';
import bgImage from '../assets/Images/homeBackgroundImg.png';

function Contact() {
  return (
  <div>
    <div id="contact-hero-section" className="d-flex justify-content-center align-items-center flex-column"
      style={{background: `url(${bgImage}) center/cover no-repeat`}}>
        <h2 className="text-uppercase hero-title">Contact Us</h2>
        <p className='hero-subheading'>Whether you need support or want to start something new, we’re here to help.</p>
    </div>

    <section id='contactSection' className='mt-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='formContainer'>
                        <div>
                            <form id='contactForm'>
                                <div class="mb-3">
                                    <label for="userName" class="form-label"><b>Name</b></label>
                                    <input type="text" class="form-control" id="userName" required/>
                                </div>
                                <div class="mb-3">
                                    <label for="userEmail" class="form-label"><b>Email</b></label>
                                    <input type="email" class="form-control" id="userEmail" required/>
                                </div>
                                <div class="mb-3">
                                    <label for="userPhone" class="form-label"><b>Phone No.</b></label>
                                    <input type="number" class="form-control" id="userPhone" required/>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label text-dark"><b>Message</b></label>
                                    <textarea class="form-control" id="message" style={{height:"100px"}}></textarea>
                                </div>
                                <button type="submit" class="btn btn-primary">Send</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='addressContainer p-3'>
                        <p className='fw-semibold text-dark m-0'>Address</p>
                        <p>NEBC CORNER Office No 309 Second Floor Near Savata Maharaj Mandir, Aher Wadi Chowk, Jadhavwadi Pune 412114</p>
                    </div>
                    <div className='emailContainer mt-3 p-3'>
                        <p className='fw-semibold text-dark m-0'>Email</p>
                        <p className='text-dark'>
                            <a className='text-dark' href="mailto:hr@ezioinfotech.co">hr@ezioinfotech.com</a>
                        </p>
                    </div>
                    <div className='emailContainer mt-3 p-3'>
                        <p className='fw-semibold text-dark m-0'>Phone No.</p>
                        <p className='text-dark'>
                            <a className='text-dark' href="tel:+9199605 88439">+91 99605 88439</a>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </section>

    {/* ✅ Universal Success Modal */}
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg">

                <div class="modal-header bg-success text-white">
                <h5 class="modal-title fw-bold" id="successModalLabel">
                    <i class="bi bi-check-circle-fill me-2"></i> Success
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>

                <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
                <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z"/>
                </svg>
                <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
                </div>

                <div class="modal-footer border-0 justify-content-center">
                    <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
                </div>

            </div>
        </div>
    </div>

  </div>
  )
}

export default Contact;